/** @type {import('tailwindcss').Config} */
export default {
  content: ["./index.html", "./src/**/*.{js,ts,jsx,tsx}", "./lib/**/*.{js,ts,jsx,tsx}"],
  theme: {
    extend: {
      colors: {
        content: {
          base: "#FFF",
          secondary: "#A69E92",
          disabled: "#474642",
        },
        border: {
          base: "#333230",
          subtle: "#1F1E1D",
          transparent: "#FFFFFF29",
        },
        background: {
          baseSolid: "#0A0A0A",
          secondarySolid: "#141414",
          backdrop: "#0A0A0AD9",
        },
        primary: {
          base: "#99815C",
          dark: "#5C4A2E",
          light: "#E5D6AE",
          lighter: "#D5D5FF",
          contrast: "#FFF",
          50: "#FAEDCD",
          100: "#F2E4BF",
          200: "#E5D6AE",
          300: "#D9C89C",
          400: "#C7B587",
          500: "#B8A576",
          600: "#99815C",
          700: "#756041",
          800: "#5C4A2E",
          900: "#524531",
          950: "#524531",
        },
        secondary: {
          base: "#333230",
          dark: "#2E2D2C",
          darker: "#1F1E1D",
          light: "#474642",
          lighter: "#726E69",
          contrast: "#FFF",
          50: "#A69E92",
          100: "#999188",
          200: "#8B857D",
          300: "#7D7872",
          400: "#726E69",
          500: "#474642",
          600: "#333230",
          700: "#2E2D2C",
          800: "#1F1E1D",
          900: "#141414",
          950: "#0A0A0A",
        },
        informative: {
          base: "#23B4C9",
          dark: "#1E869C",
          darker: "#1F6D7F",
          light: "#3CC3D4",
          lighter: "#BOEBF1",
        },
        warning: {
          base: "#D67D39",
          dark: "#C8672E",
          darker: "#A65028",
          light: "#E09F64",
          lighter: "#F1D7E7",
        },
        error: {
          base: "#EF4444",
          dark: "#DC2626",
          darker: "#B91C1C",
          light: "#F87171",
          lighter: "#FECACA",
        },
        success: {
          base: "#15A462",
          dark: "#14814F",
          darker: "#156642",
          light: "#49DF99",
          lighter: "#BAF8DA",
        },
        darkBrand: {
          50: "#A69E92",
          100: "#999188",
          200: "#8B857D",
          300: "#7D7872",
          400: "#726E69",
          500: "#474642",
          600: "#333230",
          700: "#2E2D2C",
          800: "#1F1E1D",
          900: "#141414",
          950: "#0A0A0A",
        },
        accentBrand: {
          50: "#FAEDCD",
          100: "#F2E4BF",
          200: "#E5D6AE",
          300: "#D9C89C",
          400: "#C7B587",
          500: "#B8A576",
          600: "#99815C",
          700: "#756041",
          800: "#5C4A2E",
          900: "#524531",
          950: "#524531",
        },
        slateBrand: {
          50: "#FCF7F1",
          100: "#F9EFE6",
          200: "#F3E3D2",
          300: "#EBD1B6",
          400: "#E1BD98",
          500: "#D5AA7F",
          600: "#C69565",
          700: "#AD8155",
          800: "#8C6A47",
          900: "#70573E",
          950: "#423324",
        },
        brand: {
          50: "#E7D5FF",
          100: "#FFF6E8",
          200: "#FFEED5",
          300: "#FFE1B3",
          400: "#FDD598",
          500: "#F8CC8B",
          600: "#EBBE7A",
          700: "#C49F66",
          800: "#A9834A",
          900: "#886736",
          950: "#654B24",
        },
        gray: {
          50: "#FAF7F3",
          100: "#F6F0E9",
          200: "#EEE2D7",
          300: "#E3CEBE",
          400: "#D6B6A3",
          500: "#C89D8C",
          600: "#B78274",
          700: "#B78274",
          800: "#825B51",
          900: "#694E46",
          950: "#3D2D29",
        },
      },
      backgroundImage: {
        header: "radial-gradient(720% 100.02% at 100% 38%, rgba(31, 30, 29, 0.96) 0%, rgba(20, 20, 20, 0.96) 100%)",
        dialog: "radial-gradient(51.67% 51.19% at 51.67% 0%, #2E2D2C 0%, #141414 100%)",
        homeBtn: "linear-gradient(180deg, #2E2D2C 0%, #1F1E1D 50.48%, #2E2D2C 100%)",
        grdPrimary: "radial-gradient(50% 100% at 50% 0%, #B8A576 0%, #756041 100%)",
        grdPrimaryAlt: "linear-gradient(180deg, #524531 0%, #5C4A2E 100%)",
        grdSecondary: "radial-gradient(50% 100% at 50% 0%, #2E2D2C 0%, #1F1E1D 100%)",
        grdSecondaryAlt: "linear-gradient(180deg, #2E2D2C 0%, #333230 100%)",
        bottomMenu: "radial-gradient(33.48% 103.75% at 52.2% 0%, #886736 0%, #292218 100%)",
        bottomNavBtnRound: "linear-gradient(180deg, #F8CC8B 0%, #5C4A2E 100%)",
        bottomNavBtnRoundRimLight: "radial-gradient(50% 25% at 50% 100%, #FDD598 0%, rgba(41, 34, 24, 0.00) 100%)",
        bottomNavBtnIndicatorActive: "radial-gradient(44.58% 50% at 50% 100%, #70623e 0%, #ffffff00 100%)",
        bottomNavBtnIndicator: "",
        pageTitle: "linear-gradient(180deg, #FFF 19.11%, #8B857D 71.43%)",
        tabNavSecondary: "linear-gradient(180deg,#2E2D2C 0%, #1F1E1D 100%)",
        referFriendTopSection:
          "radial-gradient(73.33% 38.02% at 73.33% 58.07%, #7f694733 0%, rgba(0, 0, 0, 0.00) 100%)",
        timerProgressBar:
          "linear-gradient(#1F1E1D,#1F1E1D),linear-gradient(90deg, #756041 0%, #C49F66 70%, #B7A575 100%)",
        timerProgressStripes:
          "linear-gradient(-45deg,rgba(255,255,255,.20) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.20) 50%,rgba(255,255,255,.20) 75%,transparent 75%,transparent)",
        card: "radial-gradient(46.81% 58.96% at 50% 0%,#333230 0%,#141414 100%)",
      },
      backgroundColor: {
        backdrop: "#0A0A0AD9",
      },
    },
    filter: {
      primary: "sepia(50%) saturate(150%) hue-rotate(1deg)",
    },
  },
  plugins: [import("@tailwindcss/typography")],
};
